import React from 'react';
import { BudgetExpenseOrIncome } from 'business/constants';
import { useTranslation } from 'react-i18next';
import { styled } from '@mui/material/styles';
import { Box } from '@mui/material';
import Typography from '@mui/material/Typography';
import {
    BudgetProposalT,
    BudgetVentilatedDataT,
    BudgetVentilatedDataWithCadrageT,
} from 'routes/BudgetModule/config/types';
import { getChartSettings } from 'routes/BudgetModule/helpers/chartHelpers';
import { BudgetProposalVentilationBy } from 'routes/BudgetModule/config/queries';
import PieChartsData from './components/BudgetPieChartData';

type Props = {
    budgetProposal: BudgetProposalT;
    ventilatedData: {
        query: QueryT;
        data: BudgetVentilatedDataWithCadrageT[] | BudgetVentilatedDataT[];
    };
    ventilationType: BudgetProposalVentilationBy;
};

const StyBudgetChartsWrapper = styled(Box, {
    name: 'StyBudgetChartsWrapper',
})({
    display: 'flex',
    justifyContent: 'space-between',
    padding: '1rem',
    background: 'white',
    borderRadius: '4px',
});

const StyTitleContainer = styled(Box, {
    name: 'StyTitle',
})(({ theme }) => ({
    backgroundColor: 'white',
    color: theme.palette.primary.main,
    padding: '16px 0 0 32px',
    borderTopLeftRadius: '4px',
    borderTopRightRadius: '4px',
}));

const BudgetChartSection: React.FC<Props> = ({
    budgetProposal,
    ventilationType,
    ventilatedData,
}) => {
    const { t } = useTranslation();
    return (
        <>
            <StyTitleContainer>
                <Typography variant="h5" sx={{ paddingBottom: '1rem' }}>
                    {t('budgetProposal.chartTitleBP', {
                        exercice: budgetProposal.exercice,
                    })}
                </Typography>
            </StyTitleContainer>
            <StyBudgetChartsWrapper>
                {[
                    BudgetExpenseOrIncome.EXPENSE,
                    BudgetExpenseOrIncome.INCOME,
                ].map((expenseType) => (
                    <PieChartsData
                        key={expenseType}
                        initialData={{
                            query: ventilatedData.query,
                            data: ventilatedData.data,
                        }}
                        budgetProposal={budgetProposal}
                        expenseOrIncome={expenseType}
                        settings={getChartSettings('pie')}
                        ventilationType={ventilationType}
                    />
                ))}
            </StyBudgetChartsWrapper>
        </>
    );
};

export default BudgetChartSection;
